import React from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputAffiliation = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Affiliations"), extra: 'Separate affiliations with a slash (e.g. "Rocky High School / Boulder Gym Youth Team")', colon: false }, props.form.getFieldDecorator('affiliation', {
    initialValue: props.initialValue || '',
    rules: [{
            max: 255,
            message: 'Affiliation is too long',
        }, {
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Input, { size: 'large', disabled: props.isDisabled })))); };
export default InputAffiliation;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthlete/InputAffiliation.tsx
// module id = 1202
// module chunks = 0